import * as types from "@/constants/mutation-names";

const state = {
  username: undefined
  , nombre: undefined
  , fotoPerfil: undefined
  , grupos: undefined
  , tipoUsuario: undefined
  , ultimaModificacionPassword: undefined
  , diasVencimiento: undefined
  , roles: []
  , fechaVencimiento: undefined
};

/* gets data from store in a fancy way */
const getters = {
  getUserData: (state) => ({ ...state })
  , getUserPermissions: (state) => state.roles
};

/* executes actions mainly async actions */
const actions = {
  [types.USER_SET_DATA]({ commit }, data) {
    /* Change store's state */
    commit(types.USER_SET_DATA, data);
  }
  , [types.USER_CLEAN_DATA]({ commit }) {
    commit(types.USER_CLEAN_DATA);
  }
  , [types.USER_SET_FOTO_PERFIL]({ commit }, data) {
    commit(types.USER_SET_FOTO_PERFIL, data);
  }
};

/* mutates the state of the vue store app */
const mutations = {
  [types.USER_SET_DATA](state, data) {
    Object.keys(data).forEach((value) => {
      state[value] = data[value];
    });
  }
  , [types.USER_CLEAN_DATA](state) {
    Object.keys(state).forEach((value) => {
      state[value] = undefined;
    });
  }
  , [types.USER_SET_FOTO_PERFIL](state, { fotoPerfil }) {
    state.fotoPerfil = fotoPerfil;
  }
};

/* Exporting the State for Auth State Module*/
export default {
  state
  , getters
  , actions
  , mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/user.js